import styled from 'styled-components';

import {
  LinearProgress as MUILinearProgress,
  TextField as MUITextField,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const Container = styled('div')`
  width: 384px;
  display: flex;
  flex-direction: column;

  &[data-is-fullscreen='true'] {
    width: 100%;
    height: 100%;
    justify-content: space-between;

    .content {
      height: auto;
      flex: 1 0;
    }
  }
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  height: 48px;
  border-bottom: 1px solid #e0e0e0;

  &:before {
    content: '';
    display: block;
    width: 4px;
    height: 100%;
    background-color: #00b0aa;
  }
`;

export const Title = styled('div')`
  margin: 0;
  flex: 1 auto;
  display: flex;
  align-items: center;
`;

export const Content = styled('div')`
  flex: 1 auto;
  height: 490px;
  overflow-y: auto;
  margin: 0.5rem 0.5rem 1rem;
  padding: 0 0.5rem;
  display: flex;
  flex-flow: column nowrap;

  & > :first-child {
    margin-top: auto;
  }
`;

export const SectionMessagesLabel = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.5rem 0;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;

  span {
    font-family: 'Poppins Medium';
    font-size: 0.75rem;
    padding: 0 1rem;
    color: #757575;
    background-color: #fff;
    z-index: 1;
  }
`;

export const Divider = styled('div')`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &:before {
    content: '';
    width: 100%;
    height: 1px;
    background-color: #e0e0e0;
    display: block;
  }
`;

export const Messages = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Actions = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
  margin-right: 0.5rem;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #757575;
    padding: 0.25rem;
  }
`;

export const Footer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-top: 1px solid #e0e0e0;
`;

export const MessageInput = withStyles({
  root: {
    width: '100%',
    '& > .MuiInputBase-root': {
      fontFamily: "'Poppins Regular'",
      borderRadius: '90px',
      backgroundColor: '#EEE',
      '& > input': {
        fontFamily: "'Poppins Medium'",
        fontSize: '0.75rem',
        color: '#333',
        paddingLeft: '1.5rem',
      },
      '& > fieldset': {
        borderColor: '#EEE',
      },
    },
  },
})(MUITextField);

export const LinearProgress = withStyles({
  root: { height: 5 },
  colorPrimary: {
    backgroundColor: '#e0f2f1',
  },
  bar: {
    backgroundColor: '#00b0aa',
  },
})(MUILinearProgress);
